"use client";
import React, { createContext, useContext, useState, useCallback } from "react";
import { BASE_URL } from "../config/config";

const ProgrammeContext = createContext();

export const ProgrammeProvider = ({ children }) => {
  const [programmes, setProgrammes] = useState([]);
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("token");

  // 🔹 FETCH PROGRAMMES
  const fetchProgrammes = useCallback(async () => {
    if (!token) return;
    setLoading(true);
    try {
      const res = await fetch(`${BASE_URL}/programs`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      const data = await res.json();
      if (res.ok && data.status === 200) {
        setProgrammes(data.data || []);
      } else {
        console.error("Fetch programmes failed:", data.message);
      }
    } catch (err) {
      console.error("Network error:", err);
    } finally {
      setLoading(false);
    }
  }, [token]);

  // 🔹 ADD PROGRAMME
  const addProgramme = async (formData) => {
  if (!formData || !(formData instanceof FormData)) return false;

  try {
    const res = await fetch(`${BASE_URL}/programs`, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${token}`, // DO NOT set Content-Type
      },
      body: formData,
    });

    const data = await res.json();

    if (res.ok && data.status === 201) {
      fetchProgrammes();
      return true;
    } else {
      return false;
    }
  } catch (err) {
    console.error("Network error during addProgramme:", err);
    return false;
  }
};




  // 🔹 UPDATE PROGRAMME
const updateProgramme = async (id, formData) => {
  if (!id || !(formData instanceof FormData)) {
    return false;
  }

  try {
    const res = await fetch(`${BASE_URL}/programs/${id}`, {
      method: "POST", // or PUT if API supports
      headers: {
        Authorization: `Bearer ${token}`, // Do NOT set Content-Type
      },
      body: formData,
    });

    const data = await res.json();

    if (res.ok && data.status === 200) {
      fetchProgrammes();
      return true;
    } else {
      return false;
    }
  } catch (err) {
    console.error("Network error during updateProgramme:", err);
    return false;
  }
};





  // 🔹 DELETE PROGRAMME
  const deleteProgramme = async (id) => {
    try {
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      const res = await fetch(`${BASE_URL}/programs/${id}`, {
        method: "DELETE",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ delete_audit_id: user.id }),
      });
      const data = await res.json();
      if (res.ok && data.status === 200) {
        setProgrammes((prev) => prev.filter((p) => p.id !== id));
      } else {
        alert(data.message || "Delete failed");
      }
    } catch (err) {
      console.error("Network error:", err);
      alert("Delete failed");
    }
  };

  return (
    <ProgrammeContext.Provider
      value={{
        programmes,
        loading,
        fetchProgrammes,
        addProgramme,
        updateProgramme,
        deleteProgramme,
      }}
    >
      {children}
    </ProgrammeContext.Provider>
  );
};

export const useProgrammes = () => useContext(ProgrammeContext);
